export default class FdxGoogleSigninButtonController {
    public onClick: () => void;
}